module.exports = __webpack_public_path__ + "img/25.68cd3c4f.jpg";